<template>
	<section id="tw-juniper-users" class="jum-view">
		<JuniperPageHeader back="/juniper" title="User Management" subtitle="Manage users, roles and permissions">
			<button
				v-if="userHasAllNeededJuniperPermissions(['clear_roles_cache','clear_permissions_cache'])"
				@click="clearRolesAndPermissionsCache()"
				class="j-action-btn"
			>
				<font-awesome-icon :icon="['fas', 'broom']" class="me-1" /> Clear Roles & Permissions Cache
			</button>
		</JuniperPageHeader>
		<div class="jum-intro mt-2">
			Manage CMS users, role definitions, and permission groups from one place.
		</div>

		<div class="jum-tabs mt-3">
			<NavTabs />
		</div>

		<router-view name="b" class="mt-3"></router-view>
		<div v-if="defaultView" class="jum-empty mt-4">
			<h4>Choose one of the tabs above to get started.</h4>
			<p>Users, Roles, and Permissions are available based on your access level.</p>
			<img src="@/assets/images/user_management_nav.svg" alt="" />
		</div>
	</section>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import NavTabs from "@/components/juniper/user-management/NavTabs";
import juniperApi from '@/api/juniperApi';
import juniperUserMixin from "@/mixins/juniperUserMixin";
export default {
	name: 'Users',
	data() {
		return {
			defaultView: true,
		}
	},
	components: {
		NavTabs
	},
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
	},

	created() {
		if (this.$route.name == 'juniperUserManagement') {
			this.defaultView = true;
		} else {
			this.defaultView = false;
		}
	},
	watch: {
		$route(to) {
            if (to.name == 'juniperUserManagement') {
                this.defaultView = true;
			} else {
				this.defaultView = false;
			}
        }
    },
	methods: {
		async clearRolesAndPermissionsCache() {
			try {
				await juniperApi.post(`/users/spatie-roles-permissions/clear-cache`,{});

                this.$swal.fire({
                    icon: 'success',
                    title: 'Cache cleared!',
                    timer: 4000,
                })

            } catch (error) {
                let message = ''
                if (error.response.data.error) {
                    for (const [key, value] of Object.entries(error.response.data.error)) {
                        console.log(key)
                        message += ` ${value} \n`
                    }
                }
                this.$swal.fire({
                    icon: 'error',
                    title: message,
                    timer: 6000,
                })
            }
		}
	},
	mixins: [juniperUserMixin]
}
</script>
<style scoped>
	.jum-view {
		width: 100%;
		padding-bottom: 36px;
	}

	.jum-intro {
		font-size: 13px;
		color: #64748b;
	}

	.jum-tabs {
		background: #ffffff;
		border: 1px solid #e2e8f0;
		border-radius: 14px;
		padding: 8px;
	}

	.jum-empty {
		background: #ffffff;
		border: 1px solid #e2e8f0;
		border-radius: 14px;
		padding: 20px;
		text-align: center;
	}

	.jum-empty h4 {
		font-size: 18px;
		font-weight: 700;
		color: #1f2937;
		margin-bottom: 6px;
	}

	.jum-empty p {
		font-size: 13px;
		color: #64748b;
		margin-bottom: 14px;
	}

	.jum-empty img {
		max-width: 460px;
		width: 100%;
	}
</style>
